import i18n from '@disy/ui/form-validation-messages.properties';

export type ValidationMessageType = Exclude<keyof ValidityStateFlags, 'customError'> | 'outOfRange';
export type ValidationMessages = Partial<Record<ValidationMessageType, string>>;

export function validationMessage(flag: ValidationMessageType, options?: Record<string, unknown>) {
  return i18n(`<${flag}>`, options);
}
